import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M13.5 6C16.4818 6 18.9555 8.17504 19.4212 11.0251C21.1556 11.2331 22.5 12.7096 22.5 14.5C22.5 16.433 20.933 18 19 18H7C4.51472 18 2.5 15.9853 2.5 13.5C2.5 11.0147 4.51472 9 7 9C7.41949 9 7.82556 9.0574 8.21081 9.16477C9.22277 7.28089 11.2118 6 13.5 6Z",
      stroke: "#E32222",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M3.5 21L20.5 4",
      stroke: "#E32222",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }